import { useContext, useEffect, useRef } from 'react';
import { Field } from 'formik';
import { useLocation } from 'react-router-dom';
import { Grid } from '@mui/material';
import HomeContext from 'src/store/home-context';
import MuiRadioGroup from 'src/components/input/MuiRadioGroup';
import CardWrapper from 'src/components/util/CardWrapper';
import BusinessStatus from 'src/components/BusinessStatus';
import IneligibleModal from 'src/components/modal/IneligibleModal';
import AuthContext from 'src/store/auth-context';

const HomePage = () => {
  const location = useLocation();
  const { account } = useContext(AuthContext);
  const { ineligibleModal } = useContext(HomeContext);
  const { openModal, closeModal, open } = ineligibleModal;
  const ineligibleToBypass = account.bypassItemization === 'X';
  const openModalRef = useRef(openModal);

  useEffect(() => {
    if (ineligibleToBypass) openModalRef.current();
  }, [ineligibleToBypass, location]);
  return (
    <>
      <CardWrapper>
        <IneligibleModal handleClose={closeModal} open={open} />
        <Grid container spacing={2}>
          {!ineligibleToBypass && (
            <Grid item xs={12}>
              <Field name="bypassItemization" type="hidden" value="Y" />
            </Grid>
          )}
          <Grid item xs={12}>
            <Field
              component={MuiRadioGroup}
              name="paperlessFlag"
              label={'I would like to receive future email notifications.'}
              row={true}
              itemValues={[1, 0]}
              itemLabels={['Yes', 'No']}
            />
          </Grid>
          <Grid item xs={12}>
            <BusinessStatus />
          </Grid>
        </Grid>
      </CardWrapper>
    </>
  );
};

export default HomePage;
